<template>
    <div>
      <Head title="QB Upload Queue" />
      <h1 class="mb-8 text-3xl font-bold">QB Upload Queue</h1>
      <div class="flex items-center justify-between mb-6">
        <search-with-date-range v-model="search.search" class="mr-4 w-full max-w-md"/>
        <date-range v-model="search.dateValue" class="mr-0 w-full max-w-md" @reset="reset"/>
      </div>
      <hr />
      <div class="flex items-center justify-between mt-5">
        <a
          v-if="invoices.data.length > 0 && url()"
          class="btn-orange px-3 py-2 text-xs cursor-pointer"
          :href="`/taxilla-validated-invoices/downloads${url()}`" 
          download
          target="__blank"
          title="Download"
        >
          <span>Download</span>
        </a>
      </div>
        <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-3 pt-3 px-3 border border-dark">Invoice Date</th>
                    <th class="pb-3 pt-3 px-3 border border-dark">Invoice Number</th>
                    <th class="pb-3 pt-3 px-3 border border-dark">Order Number</th>
                    <th class="pb-3 pt-3 px-3 border border-dark">Customer</th>
                    <th class="pb-3 pt-3 px-3 border border-dark">Order Amount</th>
                    <th class="pb-3 pt-3 px-3 border border-dark">Transport Amount</th>
                    <th class="pb-3 pt-3 px-3 border border-dark">Total Amount</th>
                    <!--<th class="pb-3 pt-3 px-3 border border-dark">Loaded By</th>
                    <th class="pb-3 pt-3 px-3 border border-dark">Validated By</th>-->
                </tr>
                <tr v-for="listp in invoices.data" :key="listp.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
                    <td class="border-t border border-dark">
                        <span class="flex items-center px-3 py-3 focus:text-orange-500">
                        {{ listp.date }}
                        </span>
                    </td>
                    <td class="border-t border border-dark">
                        <span class="flex items-center px-3 py-3 focus:text-orange-500">
                        {{ listp.invoice_number }}
                        </span>
                    </td>
                    <td class="border-t border border-dark">
                        <span class="flex items-center px-3 py-3 focus:text-orange-500">
                        {{ listp.order_number }}
                        </span>
                    </td>
                    <td class="border-t border border-dark">
                        <span class="flex items-center px-3 py-3 focus:text-orange-500">
                        {{ listp.customer_name }}
                        </span>
                    </td>
                    <td class="border-t border border-dark">
                        <span class="flex items-center px-3 py-3 focus:text-orange-500 items-end px-3 items-end justify-end">
                        {{ listp.amount }}
                        </span>
                    </td>
                    <td class="border-t border border-dark">
                        <span class="flex items-center px-3 py-3 focus:text-orange-500 items-end px-3 items-end justify-end">
                        {{ listp.transport_amount }}
                        </span>
                    </td>
                    <td class="border-t border border-dark">
                        <span class="flex items-center px-3 py-3 focus:text-orange-500 items-end px-3 items-end justify-end">
                        {{ listp.total_amount }}
                        </span>
                    </td>
                  <!--<td class="border-t border border-dark">
                        <span class="flex items-center px-3 py-3 focus:text-orange-500">
                        {{ listp.loaded_by }}
                        </span>
                    </td>
                    <td class="border-t">
                        <span class="flex items-center px-3 py-3 focus:text-orange-500">
                        {{ listp.validated_by }}
                        </span>
                    </td>-->
                </tr>
                <tr v-if="invoices.data.length === 0">
                    <td class="px-3 py-3 border-t border border-dark" colspan="7">No data found</td>
                </tr>
            </table>
        </div>
        <pagination class="mt-6" :links="invoices.links" />
    </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import SearchWithDateRange from '@/Shared/SearchWithDateRange'
import DateRange from '@/Shared/DateRange'
import pickBy from 'lodash/pickBy'
import mapValues from 'lodash/mapValues'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import Pagination from '@/Shared/Pagination'

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchWithDateRange,
    DateRange,
    Pagination
  },
  layout: Layout,
  props: {
    filters: Object,
    invoices: Object,
  },
  data() {
    return {
      search: {
        dateValue: this.filters.dateValue,
        search: this.filters.search,
      },
    }
  },
  computed: {
    role() {
      return this.$inertia.page.props.auth.user.role
    },
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/validated-invoices/', pickBy(this.search), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.search = mapValues(this.search, () => null)
    },
    url() {
      let query = '';
      if (this.search.search) {
        query += `search=${this.search.search}`;
      }
      if (this.search.dateValue) {
        if (query) {
          query += '&';
        }
        query += `dateValue=${this.search.dateValue}`;
      }
      if (query) {
        query = `?${query}`;
      }
      return query;
    },
  },
}
</script>